var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5145 12.2964C7.04092 12.0122 6.42666 12.1658 6.14251 12.6394C5.85836 13.1129 6.01192 13.7272 6.4855 14.0113L7.5145 12.2964ZM10.8462 15.4615L10.3317 16.319L11.1165 16.79L11.6549 16.0497L10.8462 15.4615ZM17.8087 7.58817C18.1336 7.14152 18.0348 6.5161 17.5882 6.19126C17.1415 5.86643 16.5161 5.96518 16.1913 6.41183L17.8087 7.58817ZM6.4855 14.0113L10.3317 16.319L11.3606 14.604L7.5145 12.2964L6.4855 14.0113ZM11.6549 16.0497L17.8087 7.58817L16.1913 6.41183L10.0374 14.8734L11.6549 16.0497Z",
    fill: "#499C47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDone);
export default __webpack_public_path__ + "static/media/arrowDone.eb51701c.svg";
export { ForwardRef as ReactComponent };